import { Component, Input, OnInit } from '@angular/core';
import { FiltersComponent } from '../../../common/filters.component';

@Component({
	selector: 'app-tourism-transport-filters',
	templateUrl: './tourism-transport-filters.component.html',
	styleUrls: ['./tourism-transport-filters.component.css'],
})
export class TourismTransportFiltersComponent extends FiltersComponent {
	filters = {
		originCityId: [],
		offerName: [],
		reservation: null,
		surname: null,
		on: 1,
	};
	@Input() originCityId: Array<any>;
	@Input() offerName: Array<any>;

	protected filtersLoad() {
		if (!this.filters || this.filters instanceof Array) {
			this.selected.emit({});
			return;
		}
		this.filters.on = 1; // hack when no filters selected
		this.router.navigate(['.'], {
			relativeTo: this.route,
			queryParams: this.filters,
			preserveFragment: true,
		});
	}
}
